export const GA4_MEASUREMENT_ID = "G-LFXJM2B7RK";

const SCRIPT_ID = "desamatic-ga4-gtag";
const LEAD_EVENTS = new Set(["whatsapp_click", "generate_lead", "contact_form_submit"]);
const recentLeadEvents = new Map();
let loadPromise = null;
let lastTrackedPath = null;

export const isPublicGA4Path = (pathname) =>
    !(
        pathname === "/admin" ||
        pathname.startsWith("/admin/") ||
        pathname === "/installer" ||
        pathname.startsWith("/installer/")
    );

const loadGoogleTag = () => {
    if (typeof window === "undefined") return Promise.resolve();
    if (loadPromise) return loadPromise;

    loadPromise = new Promise((resolve) => {
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function gtag() {
            window.dataLayer.push(arguments);
        };

        window.gtag("js", new Date());
        window.gtag("config", GA4_MEASUREMENT_ID, { send_page_view: false });

        const existing = document.getElementById(SCRIPT_ID);
        if (existing) {
            if (existing.dataset.loaded === "true") resolve();
            else {
                existing.addEventListener("load", resolve, { once: true });
                existing.addEventListener("error", resolve, { once: true });
            }
            return;
        }

        const script = document.createElement("script");
        script.id = SCRIPT_ID;
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
        script.onload = () => {
            script.dataset.loaded = "true";
            resolve();
        };
        script.onerror = resolve;
        document.head.appendChild(script);
    });

    return loadPromise;
};

export const trackPublicPageView = (pathname) => {
    if (typeof window === "undefined") return;
    if (!isPublicGA4Path(pathname)) {
        lastTrackedPath = null;
        return;
    }
    if (lastTrackedPath === pathname) return;
    lastTrackedPath = pathname;

    loadGoogleTag().then(() => {
        window.gtag?.("event", "page_view", {
            page_path: pathname,
            page_title: document.title,
            page_location: `${window.location.origin}${pathname}`,
        });
    });
};

export const trackGA4Event = (eventName, params = {}) => {
    if (typeof window === "undefined" || !LEAD_EVENTS.has(eventName) || !isPublicGA4Path(window.location.pathname)) return;
    const key = `${eventName}:${params.cta_location || params.form_name || "default"}`;
    const now = Date.now();
    if (now - (recentLeadEvents.get(key) || 0) < 750) return;
    recentLeadEvents.set(key, now);
    loadGoogleTag().then(() => window.gtag?.("event", eventName, params));
};